export const CREATE_SEO = 'CREATE_SEO';
export const UPDATE_SEO = 'UPDATE_SEO';
